import styled from "styled-components";

export const Wrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    * > svg {
        position: absolute;
        pointer-events: none;
        transform-origin: top left;
        transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
        line-height: 1;
        right: 1rem;
        top: 0.9rem;
    }
`;

export const TextField = styled.input`
    height: 3rem;
    border-radius: ${globalThis.config.sizes.borderRadius};
    border: ${globalThis.config.border.small3};
    padding: 1.5rem 2.5rem 1.5rem 3rem;
    font-size: 1rem;
    line-height: 1;
    outline: none;
    box-shadow: none;
    transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    &:focus,
    :hover,
    .active {
        border: ${globalThis.config.border.smallBlack};
    }
`;

export const MagnifierWrapper = styled.span`
    position: absolute;
    top: 0;
    background-color: ${globalThis.config.border.white};
    width: 3rem;
    height: 3rem;
    border-radius: 0.3rem;
`;

export const CloseWrapper = styled.span`
    position: absolute;
    top: 0rem;
    right: 0;
    background-color: ${globalThis.config.border.white};
    width: 2rem;
    height: 3rem;
    border-radius: 0.3rem;
    cursor: pointer;
    > svg {
        display: block;
        margin: 0 auto;
        top: 1.3rem;
        right: 0.7rem;
    }
`;
